import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=b575c4c8&scoped=true"
import script from "./LeftMenu.vue?vue&type=script&lang=js"
export * from "./LeftMenu.vue?vue&type=script&lang=js"
import style0 from "./LeftMenu.vue?vue&type=style&index=0&id=b575c4c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b575c4c8",
  null
  
)

export default component.exports